import { useCallback, useRef } from 'react';

export const useRefs = <T extends HTMLElement>() => {
    const refs = useRef<Record<string, T | null>>({});
    const setRefs = useCallback((id: string, el: T | null) => {
        refs.current[id] = el;
    }, []);
    return { refs, setRefs };
};
